import WorkspaceStatus from '../atoms/WorkspaceStatus';
import AppTable from '../atoms/AppTable';
import React from 'react';
import { MotifIcon } from '@ey-xd/motif-react';
import iconSvg from "../../assets/icons/icon.svg.json";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

function UserGroupListTable(props: any) {
    const navigate = useNavigate();
    const { tableData } = props;
    const { access } = useSelector((state: any) => state.user);

    const columns = [
        { header: 'S.No.', accessor: 'serial' ,
            render: (data)=> (
                <p>
                    { tableData.findIndex(item => item.groupId === data.groupId) + 1}
                </p>
            )
        },
        { header: 'Group Name', accessor: 'groupName', 
            render: (data)=> (
                <p className="max-w-[10rem] break-words">
                    {data?.groupName}
                </p>
            )
         },
        { header: 'Domain', accessor: 'groupDomain' },
        { header: 'Location', accessor: 'groupLocation' },
        { header: 'Description', accessor: 'groupDescription' },
        { header: 'Status', accessor: 'groupStatus',
            render: (data)=> (
                <WorkspaceStatus status={data?.groupStatus} /> 
            )
        },
        { header: 'Action', accessor: 'action',
            render: (data)=> (
                <MotifIcon title={access.write === false ? "Write access denied" : ""} onClick={ () => {
                    if(access.write === false) {
                        alert("Write access denied")
                        return;
                    }
                    navigate(`/admin/user-groups/edit/${data?.groupId}`, {state: data})
                 } }  src={iconSvg['edit-icon']} className='!w-6 cursor-pointer'/>
            )
        }
    ]
  return (
    // <div>UserGroupListTable</div>
    <AppTable columns={columns} tableData={tableData} />
  )
}

export default UserGroupListTable